import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, CheckIcon, ClipboardListIcon, LeafIcon, ListChecksIcon, MonitorSmartphoneIcon, SaladIcon, ZapIcon } from 'lucide-react';
import { openCheckout } from '../utils/checkout';
export function FinalOffer() {
  const [hasAcceptedLegal, setHasAcceptedLegal] = useState(false);
  const handleOfferContinue = () => {
    if (hasAcceptedLegal) {
      openCheckout();
    }
  };
  return <section id="oferta" className="relative overflow-hidden bg-[#071d11] px-5 py-16 text-white sm:px-8 sm:py-24" data-id="element-13" data-mp="1lfi2pupscmvz">
      <LeafIcon aria-hidden="true" className="absolute -bottom-8 -left-10 h-44 w-44 -rotate-[32deg] text-[#7d9a58]/20 blur-sm" strokeWidth={1} data-id="element-14" data-mp="204o15ggsu92t" />
      <LeafIcon aria-hidden="true" className="absolute -right-10 -top-8 h-44 w-44 rotate-[37deg] text-[#7d9a58]/15 blur-sm" strokeWidth={1} data-id="element-15" data-mp="294t7roe653fx" />

      <div className="relative mx-auto max-w-[1440px]" data-id="element-16" data-mp="243wu4j40m2xb">
        <div className="grid gap-10 lg:grid-cols-[43%_57%] lg:gap-3" data-id="element-17" data-mp="1qic2wmf985p">
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.58
        }} className="order-2 flex flex-col justify-center py-4 lg:order-1 lg:pr-10" data-id="element-18" data-mp="6oa0hgnuyc55">
            <div className="flex items-center gap-4" data-id="element-19" data-mp="pll1b5p51dmp">
              <p className="text-xs font-bold tracking-[0.25em] text-[#b9cd55]" data-id="element-20" data-mp="udkxqo601oej">
                PRODUCTO PRINCIPAL
              </p>
              <span aria-hidden="true" className="h-px w-14 bg-[#879d48]" data-id="element-21" data-mp="zco2e7i2hslz" />
            </div>
            <p className="mt-5 text-xs font-bold tracking-[0.18em] text-[#d5e29a]" data-id="element-22" data-mp="14dlkkk32umnh">
              🔥 OFERTA ESPECIAL DE LANZAMIENTO
            </p>

            <h2 className="font-display mt-4 text-4xl leading-none tracking-[-0.02em] text-[#fffef8] sm:text-5xl" data-id="element-23" data-mp="35ejfgl03viu3">
              CÓDIGO FITNESS™
            </h2>
            <p className="mt-5 max-w-[560px] text-base leading-7 text-[#eef2e6]" data-id="element-24" data-mp="30h9qf6gmp96s">
              El sistema completo que te ayudará a construir una alimentación
              saludable sin pasar hambre y con recetas que realmente
              disfrutarás.
            </p>
            <p className="mt-4 max-w-[560px] text-sm leading-7 text-[#dfe8d9]" data-id="element-25" data-mp="3o3ye68sbjvvb">
              En un solo acceso recibirás la guía principal, los tres bonos
              premium y más de 550 recetas, organizadas para ayudarte a crear
              hábitos que puedas mantener durante toda la vida.
            </p>

            <div className="mt-7 border-y border-[#79915c]/30 py-6" data-id="element-26" data-mp="3t4m1okhc9uks">
              <h3 className="text-xs font-bold tracking-[0.2em] text-[#c2d35d]" data-id="element-27" data-mp="22qwn3ba8p5vn">
                HOY RECIBES
              </h3>
              <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-28" data-mp="1yrntq7j43a0m">
                {['Guía Principal CÓDIGO FITNESS™', 'Recetario Déficit Calórico', 'Cocina Antiinflamatoria', 'Planificador Nutricional', 'Calendario de Alimentación de 30 días', 'Más de 550 recetas saludables'].map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-5 text-[#edf1e7]" data-id="element-29" data-mp="1jt38v0fxfuyd">
                    <CheckIcon className="mt-0.5 shrink-0 text-[#d5e29a]" size={15} strokeWidth={2.6} data-id="element-30" data-mp="19ytejd7fcml0" />
                    <span data-id="element-31" data-mp="10xd2l10yoceo">{benefit}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-6" data-id="element-32" data-mp="2qc9smwdi13oy">
              <p className="text-xs text-[#c6d1c0]" data-id="element-33" data-mp="2val5zh305wbx">Valor real del sistema</p>
              <p className="mt-1 text-sm text-[#b9c4b5] line-through" data-id="element-34" data-mp="2v8icgn2n5l2g">
                $197 USD
              </p>
              <p className="mt-5 text-xs font-bold tracking-[0.2em] text-[#c2d35d]" data-id="element-35" data-mp="q98x6qqokjtg">
                HOY SOLO
              </p>
              <p className="font-display mt-1 text-6xl leading-none tracking-[-0.05em] text-[#d5e29a] sm:text-7xl lg:text-8xl" data-id="element-36" data-mp="l9e7gqin609z">
                $29.99{' '}
                <span className="text-2xl tracking-normal sm:text-3xl" data-id="element-37" data-mp="hanacje6eimv">
                  USD
                </span>
              </p>
              <p className="mt-3 text-sm font-bold text-[#d5e29a]" data-id="element-38" data-mp="7i9175krq9qo">
                Ahorras más del 80%
              </p>
              <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-xs text-[#eef2e6]" data-id="element-39" data-mp="2kpoia3py50u">
                {['Pago único', 'Sin mensualidades', 'Acceso para siempre', 'Descarga inmediata'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-40" data-mp="3kqc6gx4haf8f">
                    <CheckIcon size={14} className="text-[#c2d35d]" strokeWidth={2.6} data-id="element-41" data-mp="207ruzaagu5xv" />
                    {item}
                  </span>)}
              </div>
            </div>

            <label className="mt-8 flex max-w-[560px] cursor-pointer items-start gap-3 rounded-xl border border-[#8ca36b]/35 bg-[#0e2918]/65 p-4 text-xs leading-5 text-[#e5ecdc]" data-id="element-42" data-mp="2e71a06mxqu09">
              <input type="checkbox" checked={hasAcceptedLegal} onChange={event => setHasAcceptedLegal(event.target.checked)} className="mt-0.5 h-4 w-4 shrink-0 accent-[#c9dc61]" data-id="element-43" data-mp="1heo0xntc5r2q" />
              <span data-id="element-44" data-mp="1v973bz9a4ul1">
                He leído y acepto los{' '}
                <a href="/terminos-y-condiciones" className="font-semibold text-[#d3e47a] underline underline-offset-2" data-id="element-45" data-mp="xt1ct3fh5igp">
                  Términos y Condiciones
                </a>
                , la{' '}
                <a href="/politica-de-privacidad" className="font-semibold text-[#d3e47a] underline underline-offset-2" data-id="element-46" data-mp="260xlpv45u9fe">
                  Política de Privacidad
                </a>{' '}
                y la{' '}
                <a href="/politica-de-reembolsos" className="font-semibold text-[#d3e47a] underline underline-offset-2" data-id="element-47" data-mp="2aujlwnt50kub">
                  Política de Reembolsos
                </a>
                . Entiendo que estoy adquiriendo un producto digital de acceso
                inmediato y que, por su naturaleza, no se realizan devoluciones
                ni reembolsos una vez completada la compra.
              </span>
            </label>

            <button type="button" disabled={!hasAcceptedLegal} onClick={handleOfferContinue} className="mt-5 inline-flex min-h-16 w-full max-w-[500px] items-center justify-center rounded-full bg-[#c9dc61] px-8 text-base font-bold tracking-[0.07em] text-[#102814] shadow-[0_12px_25px_rgba(0,0,0,0.32)] transition duration-300 enabled:hover:-translate-y-0.5 enabled:hover:bg-[#d8e87c] enabled:hover:shadow-[0_17px_30px_rgba(0,0,0,0.42)] disabled:cursor-not-allowed disabled:opacity-45" data-id="element-48" data-mp="37iy83fx4n6q4">
              QUIERO EMPEZAR MI CAMBIO HOY
            </button>

            <div className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2 text-[11px] text-[#eff3e8] sm:grid-cols-4" data-id="element-49" data-mp="3tthmjklxk4pz">
              <span data-id="element-50" data-mp="2l2aynoin6pe">🔒 Pago 100% seguro</span>
              <span data-id="element-51" data-mp="3k2mtnxe6i6vk">⚡ Acceso inmediato</span>
              <span data-id="element-52" data-mp="3k1txtrgrd1s7">📥 Descarga digital</span>
              <span data-id="element-53" data-mp="3p16jw9zt24tq">💻 Compatible con todos los dispositivos</span>
            </div>
            <p className="mt-5 max-w-[560px] text-xs leading-5 text-[#d6e0d0]" data-id="element-54" data-mp="3oz3lp2oi15dx">
              Empieza hoy mismo a transformar tu alimentación con un único pago.
              Recibirás acceso inmediato a todo el sistema en cuanto completes
              tu compra.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.98
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.7,
          delay: 0.08
        }} className="order-1 min-w-0 lg:order-2" data-id="element-55" data-mp="2corksydmpgse">
            <figure className="group relative mx-auto h-[480px] w-[94%] max-w-[810px] sm:h-[610px] lg:h-[720px]" data-id="element-56" data-mp="2rdnpqmke2dos">
              <div aria-hidden="true" className="absolute left-[33%] top-[7%] h-80 w-80 rounded-full bg-[#b99a5b]/20 blur-3xl" data-id="element-57" data-mp="2meuktij63v08" />
              <div aria-hidden="true" className="absolute inset-x-[8%] bottom-[8%] h-20 rounded-[50%] bg-black/70 blur-2xl" data-id="element-58" data-mp="1fw5vcdop6qex" />

              <div className="absolute right-0 top-[10%] z-40 hidden h-44 w-44 rounded-full border border-[#aabc65]/55 p-4 text-center text-[#d7e48e] lg:block" data-id="element-59" data-mp="3moc7oqb9lpxj">
                <div className="flex h-full flex-col items-center justify-center rounded-full border border-[#aabc65]/25 px-3" data-id="element-60" data-mp="3vn7cpz2kotz9">
                  <LeafIcon size={23} strokeWidth={1.4} data-id="element-61" data-mp="4acovsr7t6b3" />
                  <p className="mt-2 text-xs font-bold leading-4" data-id="element-62" data-mp="984ol8y3pwpu">
                    TU SISTEMA
                    <br data-id="element-63" data-mp="e6pkiw6blu8h" />
                    COMPLETO
                  </p>
                  <p className="mt-2 text-[8px] leading-3 text-[#d9e2b5]" data-id="element-64" data-mp="e8shy19sypn8">
                    PARA TRANSFORMAR TU SALUD DESDE LA ALIMENTACIÓN
                  </p>
                </div>
              </div>

              <img src="https://cdn.magicpatterns.com/uploads/8qqeT9itbTEfWdJ6h8w9LR/ChatGPT_Image_17_jul_2026,_09_37_05.png" alt="Guía Hábitos para una Vida Saludable" className="absolute left-1/2 top-0 z-20 w-[45%] -translate-x-1/2 rounded-sm shadow-[20px_32px_40px_rgba(0,0,0,0.5)] transition-transform duration-500 group-hover:-translate-y-1" data-id="element-65" data-mp="2kxf77rkayj09" />
              <img src="https://cdn.magicpatterns.com/uploads/ew4zYGVwXbmFnKLfyms136/bono_3_CF.png" alt="Cocina Antiinflamatoria incluida en el sistema" className="absolute bottom-[6%] left-[2%] z-20 w-[31%] -rotate-[5deg] rounded-sm shadow-[14px_24px_28px_rgba(0,0,0,0.52)] transition-transform duration-500 group-hover:-translate-x-1" data-id="element-66" data-mp="t23tb4npvalc" />
              <img src="https://cdn.magicpatterns.com/uploads/wzKGsUFS67E9tmbeSAkRpg/bono_2_CF.png" alt="Recetario Déficit Calórico incluido en el sistema" className="absolute bottom-[4%] left-[34%] z-30 w-[31%] rotate-[1deg] rounded-sm shadow-[14px_24px_30px_rgba(0,0,0,0.58)] transition-transform duration-500 group-hover:-translate-y-1" data-id="element-67" data-mp="1bsln7ckacc8a" />
              <img src="https://cdn.magicpatterns.com/uploads/qa3vi2EPaBMrMf36ySks4p/bono_1_CF.png" alt="Planificador Nutricional incluido en el sistema" className="absolute bottom-[6%] right-[1%] z-20 w-[31%] rotate-[5deg] rounded-sm shadow-[14px_24px_28px_rgba(0,0,0,0.52)] transition-transform duration-500 group-hover:translate-x-1" data-id="element-68" data-mp="3b86d617hajzd" />

              <div aria-hidden="true" className="absolute inset-x-[3%] bottom-[1%] z-10 h-9 border border-[#d3b888]/25 bg-[#aa7a45] shadow-[0_10px_16px_rgba(0,0,0,0.45)]" data-id="element-69" data-mp="3tyo0fq9jkndc" />
            </figure>

            <div className="mx-auto grid max-w-[810px] grid-cols-2 gap-px border border-[#9aaa69]/35 bg-[#9aaa69]/35 sm:grid-cols-3" data-id="element-70" data-mp="3k6qqemu9s1g7">
              {[[SaladIcon, 'Más de 550 recetas saludables'], [CalendarDaysIcon, 'Calendario de alimentación de 30 días'], [ClipboardListIcon, 'Menús completos'], [ListChecksIcon, 'Listas inteligentes'], [MonitorSmartphoneIcon, 'Compatible con todos los dispositivos'], [ZapIcon, 'Acceso inmediato']].map(([Icon, label]) => {
              const FeatureIcon = Icon as typeof SaladIcon;
              return <div key={label as string} className="flex min-h-[76px] items-center gap-3 bg-[#071d11] px-4 py-4" data-id="element-71" data-mp="217ke21h3biax">
                    <FeatureIcon size={20} strokeWidth={1.4} className="shrink-0 text-[#c9dc61]" data-id="element-72" data-mp="1rd0tcpjms0rc" />
                    <span className="text-[11px] leading-4 text-[#eff3e8]" data-id="element-73" data-mp="1ibkk4l4jy4op">
                      {label as string}
                    </span>
                  </div>;
            })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}